import React from 'react'
import { EAccessControlValue } from '@frontend/components/agromarket/core/access-control'
import { useFinancingAccessControl } from '@/pages/Financing/components/FinancingAccessControlProvider'
import { FinancingPreApprovedLoanBanner } from '@/pages/Financing/components/FinancingPreApprovedLoanBanner'
import { FinancingProductHelper } from '@/pages/Financing/components/FinancingProductHelper'

export const FinancingProductPopups = () => {
  const { resolve } = useFinancingAccessControl()

  return (
    <>
      {resolve('financing.popup.productHelper') === EAccessControlValue.VISIBLE && <FinancingProductHelper />}
      {resolve('financing.popup.preApprovedLoanBanner') === EAccessControlValue.VISIBLE && <FinancingPreApprovedLoanBanner />}
    </>
  )
}
